// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1f4c4fba","455":"3ba117db","977":"a0017b85"}[chunkId] + ".chunk.js";
};